module.exports = __webpack_public_path__ + "img/web5.92d07c8b.png";